import { makeAutoObservable, runInAction } from "mobx";
import { FullOverlayModalsControl } from "../FullOverlayModalsControl";
import { User } from "@/types/User.interface";

class UserAnotherPanelState {
  CURRENT_USER: User | null = null;
  NEW_ROLE: number = 0;
  NEW_PASSWORD: string = "";
  NEW_FIO: string = "";
  MODAL_TYPE: "delete" | "role" | "fio" | "password" | "info" | "add" = "delete";

  modalData: FullOverlayModalsControl = new FullOverlayModalsControl();

  constructor() {
    makeAutoObservable(this);
  }

  setNewRole = (role: number | string) => {
    runInAction(() => {
      this.NEW_ROLE = role as number;
    });
  };

  setNewPassword = (password: string) => {
    runInAction(() => {
      this.NEW_PASSWORD = password;
    });
  };

  setNewFio = (fio: string) => {
    runInAction(() => {
      this.NEW_FIO = fio;
    });
  };

  setModalType = (type: "delete" | "role" | "fio" | "password" | "info" | "add") => {
    runInAction(() => {
      this.MODAL_TYPE = type;
    });
  };

  setCurrentUser = (
    user: User | null,
    typeInsert: "delete" | "role" | "fio" | "password" | "info" | "add",
  ) => {
    if (user) {
      runInAction(() => {
        this.CURRENT_USER = user;
        this.NEW_ROLE = user.role;
        this.NEW_FIO = user.fio;
      });
    }
    this.setModalType(typeInsert);
    this.modalData.isOpen();
  };
}

export const userAnotherPanelState = new UserAnotherPanelState();
